import { createFullUrl } from '~/composables/util'
import { useNavigationStore } from '~/store/navigation'
import type { NavigationHookAfter } from 'vue-router'

declare global {
  interface Window {
    'de-vorige-url': string | undefined
    'nuxt-referrer': string | undefined
  }
}

export default defineNuxtPlugin((_nuxtApp) => {
  const router = useRouter()
  const navigationStore = useNavigationStore()
  const config = useRuntimeConfig()

  router.afterEach(<NavigationHookAfter>((_to, _from, failure) => {
    if (failure) {
      return
    }
    const currentFullUrl = createFullUrl(useRoute(), config)
    window['de-vorige-url'] = window['nuxt-referrer'] = navigationStore.referrer && navigationStore.referrer !== currentFullUrl ? navigationStore.referrer : undefined
  }))
})
